import { ApiService } from './api.base.service';
import { IWService } from '../iw.service';
import { Injectable } from '@angular/core';
import { BlockUnblockRequestModel } from '../../models/block-unblock-request-model';

import { SignContent } from '../../models/sign-content';
import { SignatureResponseWithoutWallet } from '../../models/signature-response';
import { GetContentWithoutWallet } from '../../models/get-content';
import { AuthService } from './auth.service';
import { Invite } from '../../models/invite-model';
import { BlockType } from '../../models/enums/blockType';
import { IncomingChatMessageStatusEnum, OutgoingChatMessageStatusEnum } from '../../models/enums/IncomingChatMessageStatusEnum';

@Injectable({ providedIn: "root" })
export class BlockUnblockService {
    baseUrl = "api/blockunblock";

    constructor(private apiService: ApiService, private iwService: IWService, private authService: AuthService) { }

    async extrSignProcessBlockUnblockInvite(bidId: number, language: string, inviteId: number = 0) {
        var fromAddress: string;
        fromAddress = await (await this.iwService.getIW()).getMainAddress();
        var response: SignatureResponseWithoutWallet;
        
                let getContent: GetContentWithoutWallet = {
                    BidId: bidId,
                    RootObjectId: inviteId,
                    language: language,
                    fromAddress: fromAddress                    
                };
                    response =  await this.apiService.post<SignatureResponseWithoutWallet>(
                    `${this.baseUrl}/getblockunblockinvitecontent`,
                    getContent
                );
            
        if (response != null) {
            let signContent: SignContent = {
                fromAddress: fromAddress,
                signatureId: response.signatureId,
                signature: '',
            };
            return await this.apiService.post(
                `${this.baseUrl}/blockunblockinvitesigncontent`,
                signContent
            );
        } else {
            return;
        }
    }

    async amiSignProcessBlockUnblockInvite(userInvite: Invite): Promise<OutgoingChatMessageStatusEnum> {

        var message = '';
        if(userInvite.isBlocked)
        {
            message = `Confirma el desbloqueo de usuario ${userInvite.fullName}`;
        }
        else {
            message = `Confirma el bloqueo de usuario ${userInvite.fullName}`;
        }
        
    
        var response = await this.apiService.post<string>(
            `${this.baseUrl}/sendNotificationAmiText`,
            { message }
        );
        
        var statusResponse: OutgoingChatMessageStatusEnum = this.getEnumNameByValue(response);
        return statusResponse;
    }


    public async blockUnblockInvite(
        inviteId: Number,
        blockUnblockType: Number,
        shouldBlock: boolean
    ): Promise<BlockUnblockRequestModel> {
        let notifyResponse = await this.apiService.post<BlockUnblockRequestModel>(
            `${this.baseUrl}/blockUnblockInvite/${inviteId}/${blockUnblockType}/${shouldBlock}`
        );

        return notifyResponse;
    }

    public async updateSignProcessBlockUnblockInvite(
        inviteId: Number
      ): Promise<any> {
        let notifyResponse = await this.apiService.post<any>(
            `${this.baseUrl}/updateSignProcessBlockUnblockInvite/${inviteId}`
        );

        return notifyResponse;
    }

    async rollBlockUnblockInviteSignContent(
        rootObjectId: number
    ) {
        return await this.apiService.post(
            `${this.baseUrl}/rollbackblockunblockinvitesigncontent/${rootObjectId}`
        );
    }

    getEnumNameByValue(value: string): OutgoingChatMessageStatusEnum {
        const intValue = parseInt(value);
        switch (intValue) {
          case OutgoingChatMessageStatusEnum.CONFIRMED:
            return OutgoingChatMessageStatusEnum.CONFIRMED;
          case OutgoingChatMessageStatusEnum.ERROR:
            return OutgoingChatMessageStatusEnum.ERROR;
          default:
            throw new Error('Valor de respuesta no válido');
        }
      }
}